// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TIAkY","cont-txt":"styles_cont-txt__sXfDK","txt1":"styles_txt1__LExUA","txt2":"styles_txt2__-XjIy","txt3":"styles_txt3__vGU6F"};